import { render, staticRenderFns } from "./SetBiometricHourModal.vue?vue&type=template&id=b6c3f026&"
import script from "./SetBiometricHourModal.vue?vue&type=script&lang=js&"
export * from "./SetBiometricHourModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6c3f026')) {
      api.createRecord('b6c3f026', component.options)
    } else {
      api.reload('b6c3f026', component.options)
    }
    module.hot.accept("./SetBiometricHourModal.vue?vue&type=template&id=b6c3f026&", function () {
      api.rerender('b6c3f026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/responsible/planing/validate/SetBiometricHourModal.vue"
export default component.exports